import { useAttendeeStatus } from "amazon-chime-sdk-component-library-react";
import { VideoMeetingRosterItem } from "./VideoMeetingRosterItem";
import { extractRoomMemberData } from "@core/features/video";
import { useVideoRoster, useVideoMeetingMembers } from "@platform/store";

export type Props = {
  /** The ID of a Chime meeting attendee. */
  attendeeId: string;
};

export function VideoMeetingRosterItemContainer({ attendeeId }: Props) {
  const { muted, videoEnabled, sharingContent } = useAttendeeStatus(attendeeId);
  const roster = useVideoRoster();
  const { roomMembersData } = useVideoMeetingMembers();

  const attendee = roster[attendeeId];

  const { displayName, roomMemberData } = extractRoomMemberData(
    attendee,
    roomMembersData
  );

  return (
    <VideoMeetingRosterItem
      muted={muted}
      videoEnabled={videoEnabled}
      sharingContent={sharingContent}
      attendeeName={displayName}
      roomMemberData={roomMemberData}
    />
  );
}

export default VideoMeetingRosterItemContainer;
